import { useEffect, useState } from "react";
import { Menu, X, MessageCircle } from "lucide-react";
import { LogoLockup } from "@/components/Logo";
import { waLink } from "@/lib/site";
import { track } from "@/lib/analytics";

const NAV = [
  { id: "segmentos", label: "Segmentos" },
  { id: "produtos", label: "Produtos" },
  { id: "diferenciais", label: "Diferenciais" },
  { id: "sobre", label: "Sobre" },
  { id: "contato", label: "Contato" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#0a2a17]/95 backdrop-blur-md shadow-[0_8px_30px_rgba(0,0,0,0.25)]"
          : "bg-[#0e3b21]"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 sm:h-20 flex items-center justify-between">
        <button
          onClick={() => scrollTo("hero")}
          data-testid="nav-logo"
          className="flex items-center focus:outline-none focus:ring-2 focus:ring-[#c9a24c] rounded-md"
        >
          <LogoLockup tone="light" size={36} />
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`nav-${n.id}`}
              onClick={() => scrollTo(n.id)}
              className="text-white/85 hover:text-[#c9a24c] text-sm font-medium tracking-wide transition-colors"
            >
              {n.label}
            </button>
          ))}
          <a
            data-testid="nav-whatsapp-btn"
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => track("whatsapp_click", { source: "navbar" })}
            className="inline-flex items-center gap-2 rounded-full px-5 py-2.5 bg-[#25D366] hover:bg-[#1ebe57] text-white text-sm font-semibold transition-all hover:scale-[1.03] shadow-lg"
          >
            <MessageCircle size={16} strokeWidth={2.4} />
            Falar no WhatsApp
          </a>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-white p-2"
          aria-label="Abrir menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#0a2a17] border-t border-white/10">
          <div className="max-w-7xl mx-auto px-5 py-4 flex flex-col gap-4">
            {NAV.map((n) => (
              <button
                key={n.id}
                data-testid={`nav-mobile-${n.id}`}
                onClick={() => scrollTo(n.id)}
                className="text-white/90 hover:text-[#c9a24c] text-left text-base font-medium py-1"
              >
                {n.label}
              </button>
            ))}
            <a
              data-testid="nav-mobile-whatsapp-btn"
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 rounded-full px-5 py-3 bg-[#25D366] text-white text-sm font-semibold"
            >
              <MessageCircle size={16} /> Falar no WhatsApp
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
